import Vue from 'vue'
import Vuex from 'vuex'
import 'animate.css';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
